import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectState } from '../../store/slices/themeSlice'
import useCustomStyles from '../../hooks/useCustomStyles'
import { accessCodesStyles } from '../../assets/styles/accessCodesStyles'
import DataInput from './components/DataInput'
import LabeledDropdown from './components/LabeledDropdown'
import CategoryDetailsCollapse from './components/CategoryDetailsCollabs'
import CustomButton from '../../components/CustomButton'
import AddNewCategoryModal from './components/AddNewCategoryModal'
import ConfirmModal from '../clients/components/ConfirmModal'
import { updateFinancialInstitution } from '../../api/awsApis'
interface ApiInfo {
  moneyhub: string
  powens: number
  yodlee: string
}
interface Category {
  name: string
  status: string
  apiProvider: string
  api: ApiInfo
}

const FinancialInstitutionsDetails = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { theme } = useSelector(selectState)
  const classes = useCustomStyles(accessCodesStyles, theme)
  const { rowData } = location.state || {}
  const obj = location.state?.rowData || {}

  const [editedData, setEditedData] = useState(() => ({
    status: obj.status,
    displayItems: { ...obj.displayItems }, // clone to avoid mutation
    groups: [...obj.groups],
    categories: [...obj.categories.map((cat: Category) => ({ ...cat }))],
    providerName: obj.providerName,
    country: obj.country,
    createdAt: obj.createdAt,
    updatedAt: obj.updatedAt,
    yodleeKey: obj.yodleeKey || '',
    moneyhubKey: obj.moneyhubKey || '',
    powensKey: obj.powensKey || '',
  }))
  const [groupInput, setGroupInput] = useState(obj.groups.join(', '))
  const [isAddNewClientModalOpen, setIsAddNewClientModalOpen] = useState(false)
  const cancelAddNewClientModal = () => {
    setIsAddNewClientModalOpen(false)
  }
  const confirmAddNewClientModal = () => {
    // setIsShareAccessCodeModalOpen(true);
    setIsAddNewClientModalOpen(false)
  }
  const [modal, setModal] = useState(false)
  if (!rowData) {
    return <div>No data available</div>
  }

  const confirmChanges = () => {
    setEditedData((prev) => ({
      ...prev,
      groups: groupInput.split(',').map((item: string) => item.trim()),
    }))
    setModal(true)
  }

  const handleSubmit = async () => {
    // add groupInput to editedData

    setModal(false)
    console.log('Submitted Data:', editedData)
    // merge editedData with rowData
    const updatedData = {
      ...rowData,
      ...editedData,
      groups: groupInput.split(',').map((item: string) => item.trim()),
    }

    //update the financial institution
    await updateFinancialInstitution(updatedData)
      .then((response) => {
        console.log('Update successful:', response)
        alert('Financial Institution updated successfully')
        navigate(-1)
      })
      .catch((error) => {
        console.error('Error updating financial institution:', error)
        alert('Failed to update financial institution')
      })

    console.log('Updated Data:', updatedData)
  }
  return (
    <div className={classes.container}>
      <div className={classes.tableContainer}>
        <h2 className={classes.header}>FINANCIAL INSTITUTIONS DETAILS</h2>
      </div>
      <div style={{ width: '75%' }}>
        <DataInput label="Provider Name" value={editedData.providerName} />
        <DataInput label="Country" value={editedData.country} />
        <DataInput
          label="Date Created"
          value={editedData.createdAt}
          isDate={true}
        />
        <DataInput
          label="Date Updated"
          value={editedData.updatedAt}
          isDate={true}
        />
        <LabeledDropdown
          label="Status"
          options={[
            { key: '1', value: 'Active' },
            { key: '2', value: 'Inactive' },
          ]}
          initialState={editedData.status}
          handleSelect={(value) => {
            console.log('Selected:', value)
            setEditedData((prev) => ({
              ...prev,
              status: value,
            }))
          }}
        />
        <p
          style={{
            fontFamily: 'Gilroy-Regular',
            fontSize: '16px',
            padding: '8px 0',
          }}
        >
          Display Name
        </p>
        <DataInput
          label="EN"
          value={editedData.displayItems.language.en}
          isInput
          onChange={(newValue) => {
            console.log(newValue)
            setEditedData((prev) => ({
              ...prev,
              displayItems: {
                ...prev.displayItems,
                language: {
                  ...prev.displayItems.language,
                  en: newValue,
                },
              },
            }))
          }}
        />
        <DataInput
          label="FR"
          value={editedData.displayItems.language.fr}
          isInput
          onChange={(newValue) => {
            setEditedData((prev) => ({
              ...prev,
              displayItems: {
                ...prev.displayItems,
                language: {
                  ...prev.displayItems.language,
                  fr: newValue,
                },
              },
            }))
          }}
        />
        <div
          style={{
            padding: '10px 15px',
            // width: "100%",
            minWidth: 50,

            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            // backgroundColor: "red",
          }}
        >
          <h3
            style={{
              fontWeight: 'bold',
              color: '#777',
              minWidth: 50,
              fontFamily: 'Gilroy-Regular',
              fontSize: 18,
              textAlign: 'left',
              verticalAlign: 'middle',
            }}
          >
            Categories
          </h3>
          <p
            style={{
              fontWeight: 'bold',
              color: '#777',
              minWidth: '50%',
              fontFamily: 'Gilroy-Regular',
              fontSize: 18,
              textAlign: 'right',
              verticalAlign: 'middle',
              cursor: 'pointer',
            }}
            onClick={() => setIsAddNewClientModalOpen(true)}
          >
            +Add Category
          </p>
        </div>

        {editedData.categories.map((cat, index) => (
          <CategoryDetailsCollapse
            key={index}
            category={cat}
            index={index}
            onCategoryChange={(updatedCategory) => {
              setEditedData((prev) => {
                const updatedCategories = [...prev.categories]
                updatedCategories[index] = updatedCategory
                return { ...prev, categories: updatedCategories }
              })
            }}
          />
        ))}

        <div
          style={{
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '16px',
            maxWidth: '100%',
            padding: '8px 12px',
          }}
        >
          <label
            style={{
              width: '100%',
              // marginRight: "12px",
              fontWeight: '500',
              fontSize: '16px',
              fontFamily: 'Gilroy-Regular',
              // whiteSpace: "nowrap",
              marginBottom: '8px',
            }}
          >
            Group (comma separated if multiple)
          </label>
          <input
            type="text"
            value={groupInput}
            onChange={(e) => {
              setGroupInput(e.target.value)
            }}
            style={{
              width: '100%',

              padding: '8px 12px',
              border: '0px solid #ccc',
              borderRadius: '6px',
              backgroundColor: '#fff',
              fontFamily: 'Gilroy-Regular',
              // flex: 1,
              fontSize: '16px',
              minHeight: '20px',
            }}
          />
        </div>

        <CustomButton
          title={'Save Changes'}
          handleClick={confirmChanges}
          name={''}
          loading={false}
        />
      </div>
      <AddNewCategoryModal
        isOpen={isAddNewClientModalOpen}
        onConfirm={confirmAddNewClientModal}
        onCancel={cancelAddNewClientModal}
        onAddCategory={(newCategory) => {
          setEditedData((prev) => ({
            ...prev,
            categories: [...prev.categories, newCategory],
          }))
        }}
        existingData={editedData}
      />
      <ConfirmModal
        isOpen={modal}
        onClose={() => setModal(false)}
        onConfirm={handleSubmit}
        title="Confirm changes to Financial Institution Details"
        description={
          <>
            You’ve updated key details for this <br />
            financial institution. Please confirm to
            <br />
            apply the updates
          </>
        }
      />
    </div>
  )
}

export default FinancialInstitutionsDetails
